import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';

interface SelectionPageHeaderProps {
  title: string;
  companyId: number | null;
  returnPath?: string;
  children?: ReactNode;
}

export default function SelectionPageHeader({
  title,
  companyId,
  returnPath,
  children,
}: SelectionPageHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (returnPath) {
      navigate(-1);
      return;
    }
    navigate(`/companies/${companyId}/home`);
  };

  return (
    <>
      <Box
        sx={{
          position: 'sticky',
          top: 64,
          zIndex: 10,
          backgroundColor: 'background.default',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          py: 1,
          mb: 0.5,
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          size="small"
        >
          {returnPath ? 'Назад' : 'На головну'}
        </Button>
        <Typography
          variant="button"
          component="h1"
          noWrap
          sx={{
            minWidth: 0,
            pr: { xs: '9px', sm: '10px' },
            color: 'primary.main',
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: { xs: 1, sm: 2 },
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
}

interface ConfirmSelectionButtonProps {
  onClick: () => void;
  count?: number;
  disabled?: boolean;
}

export function ConfirmSelectionButton({
  onClick,
  count,
  disabled,
}: ConfirmSelectionButtonProps) {
  return (
    <Button
      variant="contained"
      color="success"
      startIcon={<CheckIcon />}
      onClick={onClick}
      disabled={disabled}
    >
      {count === undefined ? 'Підтвердити' : `Підтвердити (${count})`}
    </Button>
  );
}
